
    angular.module('graph').controller('ph-feed-filter-ctrl', [
        '$scope', '$rootScope', 'ph-core', 'ph-feed-term',
        function ($scope, $root, $core, $term) {
            var $walk = function ($array, $call) {
                for (var i = 0; i < $array.length; i++) {
                    $call($array[i]);

                    if ($array[i].children.length > 0)
                        $walk($array[i].children, $call);
                }
            };

            $scope.ui = {
                mode: 'my'
            };

            $scope.categories = new Array;

            $scope.groups = new Array;

            $scope.attachment = {
                'document'          : 'Document',
                'spreadsheet'       : 'Spreadsheet',
                'presentation'      : 'Presentation',
                'archive'           : 'Archive',
                'agenatrader'       : 'Agenatrader'
            };

            $scope.filter = {
                categories: new Array,
                groups: new Object,
                attachment: {
                    'document'         : true,
                    'spreadsheet'      : true,
                    'presentation'     : true,
                    'archive'          : true,
                    'agenatrader'      : true
                },
                select: {
                    group: {
                        all: true
                    },
                    attach: {
                        all: true
                    }
                }
            };

            $scope.query = {
                group: new Array,
                attach: new Array,
                compile: function () {
                    $scope.query.group = new Array;
                    $scope.query.attach = new Array;

                    for (var ix in $scope.groups) {
                        var group = $scope.groups[ix];

                        if ($scope.filter.groups[group.id] === true && $scope.fn.group.filter(group))
                            $scope.query.group.push(group.id);
                    }

                    for (var type in $scope.filter.attachment) {
                        if ($scope.filter.attachment[type] === true)
                            $scope.query.attach.push(type)
                    }
                }
            };

            $scope.$http = {
                load: function () {
                    $term.$get().then(function ($response) {
                        var $data = $response.data.data;

                        $scope.categories = $data.tree;

                        $scope.groups = $data.groups.data;

                        for (var i = 0; i < $scope.groups.length; i++) {
                            $scope.filter.groups[$scope.groups[i].id] = true;

                            $scope.query.group.push($scope.groups[i].id);
                        }
                    });
                }
            };

            $scope.filtrate = function () {
                var $query = $core.$uri.$query.new({
                    groups: $scope.query.group.join(','),
                    attaches: encodeURIComponent($scope.query.attach.join(','))
                });

                $root.$broadcast('ph-root-feed-update', $query);
            };

            $scope.fn = {
                'category': {
                    'change': function ($node, $selected, $tree) {
                        $scope.filter.categories = new Array;

                        $walk($tree, function ($node) {
                            if ($node.selected === true)
                                $scope.filter.categories.push($node.id);
                        });

                        $scope.query.compile();
                    }
                },
                'group': {
                    'all': function () {
                        if ($scope.filter.select.group.all === true) {
                            for (var id in $scope.filter.groups)
                                $scope.filter.groups[id] = true;
                        } else {
                            for (var id in $scope.filter.groups)
                                $scope.filter.groups[id] = false;
                        }

                        $scope.query.compile();
                    },
                    'change': function ($id) {
                        $scope.filter.select.group.all = false;

                        for (var ix in $scope.groups) {
                            var group = $scope.groups[ix];

                            if ($scope.filter.groups[group.id] === true && $scope.fn.group.filter(group)) {
                                $scope.filter.select.group.all = true;
                                break;
                            }
                        }

                        $scope.query.compile();
                    },
                    'filter': function ($group) {
                        var $collection = $scope.filter.categories;

                        return $collection.length <= 0 || $collection.indexOf(
                                $group.category_id
                            ) !== -1;
                    }
                },
                'attach' : {
                    'all': function () {
                        if ($scope.filter.select.attach.all === true) {
                            for (var type in $scope.filter.attachment)
                                $scope.filter.attachment[type] = true;
                        } else {
                            for (var type in $scope.filter.attachment)
                                $scope.filter.attachment[type] = false;
                        }

                        $scope.query.compile();
                    },
                    'change': function (key) {
                        $scope.filter.select.attach.all = false;

                        for (var type in $scope.filter.attachment) {

                            if ($scope.filter.attachment[type] === true) {
                                $scope.filter.select.attach.all = true;
                                break;
                            }
                        }

                        $scope.query.compile();
                    }
                },
                'filter' : {
                    all: function () {
                        $scope.ui.mode = 'all';

                        var $q = $core.$uri.$query.new({
                            yard: "all"
                        });

                        $scope.fn.filter.cast($q);
                    },
                    my: function () {
                        $scope.ui.mode = 'my';

                        var $q = $core.$uri.$query.new({
                            yard: "my"
                        });

                        $scope.fn.filter.cast($q);
                    },
                    man: function () {
                        $scope.ui.mode = 'man';
                        var $q = $core.$uri.$query.new({
                            groups: $scope.query.group.join(','),
                            attaches: encodeURIComponent($scope.query.attach.join(','))
                        });

                        $scope.fn.filter.cast($q);
                    },
                    cast: function ($query) {
                        $root.$broadcast('ph-root-feed-update', $query);
                    }
                }
            };

            $scope.$http.load();
            $scope.fn.group.all();
            $scope.fn.attach.all();
        }
    ]);

angular.module('graph').config(['ivhTreeviewOptionsProvider', function (ivhTreeviewOptionsProvider) {
    ivhTreeviewOptionsProvider.set({
        defaultSelectedState: false,
        validate: true
    });
}]);
